import { TourId } from 'webapp/enums/tour';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import WizardSecondPopupComponent from 'webapp/components/wizard/tour/popup-wizard-second';

import TourBase from 'webapp/models-custom/tour';

export default class WizardSecondTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.WIZARD_SECOND;

	override popupComponent = WizardSecondPopupComponent;

	get id(): string {
		return TourId.WIZARD_SECOND;
	}

	override get keyForPersistantDone(): string {
		return WizardSecondTour.keyForPersistantDone;
	}

	override start(): void {
		super.start();
		this.popupService
			.createModal(this.popupComponent, {
				popupClass: 'wizard wizard-second',
				closeOnOverlayClick: false,
			})
			.open();
		this.markDone(); // once seen, it's done
	}

	// no stepData - all is in modal.wizard-second
}
